$(window).load(function() {
  var window_width = $(window).width();
  if(window_width < 1025){
  } else {
    ajaxCart.load();
  }

});

$('.AddToCart_btn_cls').click(function(evt) {
  evt.preventDefault();
  var formclass = $(this).parents('form').attr('id');
  var form = $('#'+formclass);
  if(form.hasClass('discount_form')){
    var qty = $('input[name="quantity"]', form).val();
    var title = qty + "+";
    if(qty >= $('#product-select option:last').val()){
      $('#product-select option:last').prop('selected', true);
    }
    $('#product-select option[data-title="' + title + '"]').prop('selected', true);
  }
  ShopifyAPI.addItemFromForm('#'+formclass);
  return false;
});


var main_div_id = $(".cart_hover_btn_cls");
$(main_div_id).mouseover(function(){
  $(this).find(".cart_hover_code").show();
});
$(main_div_id).mouseout(function(){
  $(this).find(".cart_hover_code").hide();
});

jQuery('.bg_img').each(function() {

  var el = $(this),
      src = el.attr('src'),
      parent = el.parent();
  //height = el.height();	

  parent.css({
    'background-image': 'url(' + src + ')',
    'background-size': 'cover',
    'background-position': 'center'
    //'height':height 
  });

  el.hide();
});


var windowWidth = $(window).width();
//if(windowWidth <= 800){

  $(window).scroll(function(){
    var sticky = $('.sticky'),
        scroll = $(window).scrollTop();

    if (scroll > 0) { sticky.addClass('fixed');}
    else {sticky.removeClass('fixed');}
  });
//}


$(document).ready(function(e) {
  $('.parallax-window').jarallax({
    speed: 0.1,
    /* imgWidth: 1920,
         imgHeight: 1190*/
  });
  
});

function minHeight(){
  var windowHeight = $(window).innerHeight();
  var headerHeight = $('.header-section').innerHeight();
  var footerHeight = $('.footer-section').innerHeight();
  var middleHeight = windowHeight - headerHeight - footerHeight;
  //console.log( windowHeight +"-"+ headerHeight +"-"+ footerHeight )
  $('.middle_content').css('min-height',middleHeight);

}

$(document).ready(function(e) {
  minHeight();
});

$(window).resize(function() {
  minHeight();
});

 
/* product detail */

  $('.product-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    dots: false,
    adaptiveHeight:true,
    asNavFor: '.product-nav'
  });

  $('.product-nav').slick({
    autoplay: false,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    draggable: false,
    //centerPadding: "75px",
    infinite: true,
    vertical: true,
    speed: 1000,
    //centerMode: true,
    autoplaySpeed: 2000,
    asNavFor: '.product-for',
    useTransform: true,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    adaptiveHeight: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 4,
          vertical: true
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 3,
          vertical: true
        }
      }
    ]
  });
 



var maxHeight = 0;

$(".product-nav,.product-for li").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});

$(".product-nav,.product-for li").height(maxHeight);




function equalizer(){
    var max = -1;

    $('.pro-wrap').each(function() {

      var minHeight = $(this).innerHeight();
      max = minHeight > max ? minHeight : max;

    });  
    $(".pro-wrap").css('min-height',max) 
  }

  jQuery(document).ready(function() {
    equalizer();
  });
  
  jQuery(window).resize(function() {
    equalizer();
  });












